import React from 'react';
import {Helmet} from 'react-helmet';
import ReactMarkdown from 'react-markdown';

import termsOfService from './terms-of-service.md';

const TermsOfService = () => (
  <div className='container'>
    <Helmet>
      <title>Terms of Service | ImageResize.org</title>
    </Helmet>
    <ReactMarkdown className='section' source={termsOfService} />
  </div>
);

export default TermsOfService;



// WEBPACK FOOTER //
// ./src/containers/TermsOfService/index.jsx